import ElementReveal from './ElementReveal.vue';

export { ElementReveal };
